import cn from 'classnames';
import React, { FC, useMemo } from 'react';

import { CircleDivisionData, CircleDivisions } from '@.partials';
import { DEFAULT_ANALYTICS_CHART_COLORS } from '@/Components/Partials/Analytics/constants';
import { ChartDatasetValues } from '@/Types/analytics';

import S from './styles.module.scss';

type HowManyUsersHaveCompletedWizardChartProps = {
    data: ChartDatasetValues;
    mini?: boolean;
};

export const HowManyUsersHaveCompletedWizardChart: FC<HowManyUsersHaveCompletedWizardChartProps> = ({ data, mini = false }) => {
    const circleDivisionsData = useMemo<CircleDivisionData[]>(
        () =>
            data.map((dataItem, index) => ({
                value: dataItem.value,
                color: DEFAULT_ANALYTICS_CHART_COLORS[index],
                label: dataItem.label,
                pct: dataItem.pct,
            })),
        [data]
    );

    return (
        <div className={S.wrapper}>
            <h3 className={cn(S.title, { [S['title-mini']]: mini })}>How many users have completed Wizard</h3>
            <div className={cn(S.how_many_have_completed_wizard, { [S['how_many_have_completed_wizard-mini']]: mini })}>
                <CircleDivisions data={circleDivisionsData} showLegend={!mini} textTotal={'Total Customers'} />
            </div>
        </div>
    );
};
